import { Controller } from "@hotwired/stimulus"

// Crosshair readout for the /platform revenue-vs-COGS trend chart. The bars are rendered
// server side (see PlatformMetricsHelper#platform_trend_chart) — this only finds the nearest
// day and shows its figures, so the chart is fully readable with JS off. Each point already
// carries its horizontal position as a 0–1 fraction of the plot, so there is no geometry
// here to drift out of sync with the SVG.
export default class extends Controller {
  static values = { points: Array }
  static targets = ["crosshair", "tooltip", "surface"]

  move(event) {
    const points = this.pointsValue
    if (!points.length) return

    const box = this.surfaceTarget.getBoundingClientRect()
    const fraction = (event.clientX - box.left) / box.width
    let nearest = 0
    for (let i = 1; i < points.length; i++) {
      if (Math.abs(points[i].at - fraction) < Math.abs(points[nearest].at - fraction)) nearest = i
    }

    const point = points[nearest]
    const x = point.at * box.width
    this.crosshairTarget.style.left = `${x}px`
    this.crosshairTarget.classList.remove("hidden")

    // COGS is absent from every point while a usage family is selected (vendor cost carries
    // no usage type). No cost means no margin either — computing one from revenue alone would
    // report the filtered revenue as pure profit.
    let readout = `<div class="font-semibold">${point.label}</div><div>Revenue ${point.revenue}</div>`
    if (point.cost !== undefined) {
      readout += `<div>COGS ${point.cost}</div><div class="text-base-content/60">Margin ${point.margin}</div>`
    }
    this.tooltipTarget.innerHTML = readout
    this.tooltipTarget.classList.remove("hidden")
    // Flip to the left of the cursor near the right edge so the readout stays on screen.
    const width = this.tooltipTarget.offsetWidth
    this.tooltipTarget.style.left = `${x + width + 12 > box.width ? Math.max(0, x - width - 8) : x + 8}px`
    this.tooltipTarget.style.top = "4px"
  }

  hide() {
    this.crosshairTarget.classList.add("hidden")
    this.tooltipTarget.classList.add("hidden")
  }
}
